import React from "react";

function ErrorSvg({ height, width, color }) {
  return (
    <svg
      xmlns="
    http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={0.9}
      stroke="currentColor"
      height={height || 20}
      width={width || 20}
      color={color || "black"}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z"
      />
    </svg>
  );
}

export default ErrorSvg;
